export default {
  default: {
    error: ``,
    success: ``,
  },
  create: {
    error: () => `Sorry, an error occurred requesting access to this account, please try again`,
    401: () => `Sorry, you don't have permission to request access to an account`,
  },
};
